module.exports = __webpack_public_path__ + "static/img/5.978104d8.webp";